
import PriceDetailComponent from '@components/PriceDetailComponent/PriceDetailComponent';
import styles from './PriceDetailPage.module.css';
import { useEffect } from 'react'
import { useSelector } from 'react-redux';
import { useParams } from 'react-router';
import usePrice from '@hooks/usePrice';

const PriceDetailPage = () => {
  const { myReferenceNumber } = useParams();
  const { handleGetPriceById } = usePrice();
  const { singlePriceData } = useSelector((state) => state.price);

  useEffect(() => {
    if(myReferenceNumber){
      handleGetPriceById (myReferenceNumber);
    }
  },[myReferenceNumber])

  return (
    <div className={styles.Wrapper}>
      <PriceDetailComponent priceData={singlePriceData?.data[0]} />
    </div>
  )
}

export default PriceDetailPage
